/**
 * QUI TIENT LE PARC, côté écran — module PUR.
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * ⚠️ MIROIR de `peutGererParc` (`backend/src/roles-acces.ts`). Le serveur fait
 * foi : il refuse la création d'un équipement, sa fiche d'identification, son
 * statut, le plan de maintenance, les calibrations, les incertitudes et le
 * réglage des relevés de température à qui n'a ni `rq` ni `metro`. Cette
 * fonction ne sert qu'à ne pas PROPOSER un geste qui sera refusé.
 *
 * Décision du 27/10/2026 : le rôle Métrologie tient le parc comme le RQ. Avant,
 * chaque écran écrivait `session.roles.includes('rq')` — ajouter un rôle aurait
 * voulu dire le retrouver dans une vingtaine de fichiers. Un cliquet
 * (`front-droits-parc`) compare cette liste à celle du serveur.
 */

/** Les rôles qui tiennent le parc. */
export const ROLES_PARC = ['rq', 'metro'];

export const peutGererParc = (roles: string[] | null | undefined): boolean =>
  ROLES_PARC.some((r) => (roles || []).includes(r));
